
namespace TabAurous.Finance {

    @Serenity.Decorators.registerClass()
    export class ExpenseGrid extends _Ext.GridBase<ExpenseRow, any> {
        protected getColumnsKey() { return 'Finance.Expense'; }
        protected getDialogType() { return ExpenseDialog; }
        protected getIdProperty() { return ExpenseRow.idProperty; }
        protected getInsertPermission() { return ExpenseRow.insertPermission; }
        protected getLocalTextPrefix() { return ExpenseRow.localTextPrefix; }
        protected getService() { return ExpenseService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected addButtonClick() {

            let now = new Date(); 

            var voucherNo = FormatHelper.GetVoucherNo(60);
            var userDefinition = Q.Authorization.userDefinition;
            this.editItem(<ExpenseRow>{
                VoucherNo: voucherNo,
                VoucherTypeId: 60,
                TransDate: now.toDateString(),
                CompanyId: userDefinition.CompanyId,
                FinancialYearId: userDefinition.FinancialYearId,
                UserId: userDefinition.UserId,
                CurrencyId: userDefinition.CurrencyId,
            });
        }
    }
}